import {Origin} from "../../libs/enum/origin.enum";

/**
 * Ein Rechtsdokument, wie `core` es ausliefert.
 *
 * `/legal` ist die einzige Quelle; `dash` zeigt nur an, was von dort kommt.
 * Insbesondere wird der Text **nicht** hier gerendert und **nicht** hier
 * gehasht — die Pruefsumme muss ueber genau den Wortlaut gebildet sein, den
 * `core` ausgeliefert hat.
 */
export class LegalDocumentDto {

  public readonly type!: string;
  /** Verzeichnisname unter `/legal`, z.B. `legal-notice`. */
  public readonly document!: string;
  public readonly version!: number;
  public readonly status!: string;
  public readonly validFrom: string | undefined;
  public readonly language!: string;
  public readonly platform: Origin | undefined;
  public readonly html!: string;
  public readonly sha256!: string;
  public readonly availableVersions: number[] = [];

  constructor(init?: Partial<LegalDocumentDto> | undefined) {
    Object.assign(this, init);
  }
}
